import React, { useState } from "react";
import { TextField, IconButton } from "@mui/material";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { SelectProduct } from "../../../types/salon.types";

interface OrderItemProps {
  product: SelectProduct;
  onQuantityChange: (productId: string, newQuantity: number) => void;
  onPriceChange: (productId: string, newPrice: string) => void;
  onRemove: (productId: string) => void;
}

const OrderItem: React.FC<OrderItemProps> = ({
  product,
  onQuantityChange,
  onPriceChange,
  onRemove
}) => {
  const [isEditingPrice, setIsEditingPrice] = useState(false);

  const handleDecrease = () => {
    if (product.quantity && product.quantity > 1) {
      onQuantityChange(product._id.$oid, product.quantity - 1);
    }
  };

  const handleIncrease = () => {
    onQuantityChange(product._id.$oid, (product.quantity || 1) + 1);
  };

  const handlePriceChange = (newPrice: string) => {
    onPriceChange(product._id.$oid, newPrice);
    setIsEditingPrice(false);
  };

  return (
    <div className="selected-product-item">
      <div className="product-info-section">
        <div className="product-name-wrapper">
          <span className="product-name-text">{product.ProductName}</span>
          <span className="product-quantity-badge">x{product.quantity || 1}</span>
        </div>

        <div className="product-controls">
          <div className="quantity-adjuster">
            <button
              onClick={handleDecrease}
              className="quantity-btn decrease"
              disabled={(product.quantity || 1) <= 1}
            >
              −
            </button>
            <span className="quantity-value">{product.quantity || 1}</span>
            <button onClick={handleIncrease} className="quantity-btn increase">
              +
            </button>
          </div>
        </div>
      </div>

      <div className="product-price-section">
        <div className="price-edit-wrapper">
          {isEditingPrice ? (
            <TextField
              type="number"
              value={product.Amount}
              onChange={(e) => onPriceChange(product._id.$oid, e.target.value)}
              onBlur={() => setIsEditingPrice(false)}
              autoFocus
              size="small"
              variant="outlined"
              sx={{
                width: "90px",
                "& .MuiOutlinedInput-root": { height: "36px" },
                "& .MuiInputBase-input": { 
                  padding: "8px 10px", 
                  textAlign: "right", 
                  fontWeight: "500", 
                  fontSize: "0.875rem" 
                },
              }}
              inputProps={{ min: 0, step: "0.01" }}
            />
          ) : (
            <div 
              className="price-display clickable" 
              onClick={() => setIsEditingPrice(true)}
            >
              {(parseFloat(product.Amount) * (product.quantity || 1)).toFixed(2)} QAR
            </div>
          )}
        </div>

        <IconButton
          aria-label="delete"
          className="delete-btn"
          onClick={() => onRemove(product._id.$oid)}
          sx={{ 
            marginLeft: "8px", 
            "&:hover": { backgroundColor: "rgba(255, 68, 68, 0.08)" } 
          }}
        >
          <DeleteIcon fontSize="small" sx={{ color: "#ff4444" }} />
        </IconButton>
      </div>
    </div>
  );
};

export default OrderItem;